import React from "react";
import { Box, SkeletonLoader, Stack } from "@bookingcom/bui-react";
const PriceLoading = ({ travellersCount, variant = "desktop" }) => {
    const ratio = variant === "mobile" ? "4:1" : "3:1";
    const ratioMultipleTravellers = variant === "mobile" ? "5:1" : "3:1";
    const largeWidth = "120px";
    const largeHeight = "40px";
    const smallWidth = "50px";
    return (React.createElement(Stack, { alignItems: "end", justifyContent: "end", gap: 1, mixin: { width: largeWidth }, attributes: { style: { justifySelf: "end" } } }, travellersCount === 1 ? (React.createElement(Box, { padding: 0, mixin: { width: largeWidth, height: largeHeight } },
        React.createElement(SkeletonLoader, { width: largeWidth, variant: "box", aspectRatio: ratio }))) : (React.createElement(React.Fragment, null,
        React.createElement(Box, { padding: 0, mixin: { width: largeWidth, height: largeHeight } },
            React.createElement(SkeletonLoader, { width: largeWidth, variant: "box", aspectRatio: ratioMultipleTravellers })),
        React.createElement(SkeletonLoader, { width: smallWidth, variant: "one-line" })))));
};
export default PriceLoading;
